// eslint-disable-next-line no-unused-vars
interface Window {
  addToCart: () => void
}

window.addToCart = function (articleNb: string = ''): void {
  const cart = window.open(
    'http://fm.isydistribution.se/Broschyr/EX11046.lasso?article=' + articleNb,
    'cartwin',
    'width=800, height=600, scrollbars, resizable, status',
  )
  if (cart) {
    cart.focus()
  }
}
